import {connect} from 'react-redux'
import * as action from '../../../state/image/action'
import * as selector from '../../../state/image/selector'
import * as customerSelector from '../../../state/detail/selector'
import {selectCanSeeImages} from '../../../../security/state/auth/selector'
import CustomerPreCheckinImageWidget from "./CustomerPreCheckinImageWidget";

const mapStateToProps = (state, props) => {
    return {
        customerId: customerSelector.selectCustomerId(state),
        canSeeImages: selectCanSeeImages(state),
        imageVersionList: selector.selectOrderedImageVersionList(state),
        showImages: selector.selectShowImages(state),
    }
}

const mapDispatchToProps = {
    uploadCustomerImage: action.uploadCustomerImage,
    rotateCustomerImage: action.rotateCustomerImage,
    toggleImageView: action.toggleImageView,
    setImageTypeMetaData: action.setImageTypeMetaData,
    findImageVersion: action.findImageVersion,
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerPreCheckinImageWidget)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/customerPreCheckinImageWidget/CustomerPreCheckinImageWidgetContainer.js